import {senPostRequestExpectBlob} from "./axiosFormWrapper";
import {unzipSync, strFromU8} from 'fflate';

const noop = () => {
};

export class SingleTextFileZipExtractor {
    public static load(url) {
        return new Promise<string>(resolve => {
            fetch(url)       // 1) fetch the url
                .then(function (response) {                       // 2) filter on 200 OK
                    if (response.status === 200 || response.status === 0) {
                        return Promise.resolve(response.blob());
                    } else {
                        return Promise.reject(new Error(response.statusText));
                    }
                }).then(response => {
                    response.arrayBuffer().then(r => resolve(strFromU8(Object.values(unzipSync(new Uint8Array(r)))[0])));
                })
                .catch(text=>console.log("catched statustext "+text))
        })
    }
}

export class PNGZipLoader {
    public static load(url, data, callbackForFile: (relativePath, blob) => void, numberOfFilesReporter: (numberOfFiles) => void = noop) {
        return new Promise<void>(resolve => {
            const loadedDataPromise = senPostRequestExpectBlob(url, data);
            PNGZipLoader.processResolvedLoadPromise(loadedDataPromise, callbackForFile, numberOfFilesReporter).then(resolve);
        })
    }

    protected static processResolvedLoadPromise(promise: Promise<{
        data: Blob
    }>, callbackForFile, numberOfFilesReporter: (numberOfFiles) => void = noop): Promise<void> {
        return new Promise<void>(resolve => {
            promise.then(response => {
                if (response.data.size === 0) {
                    resolve();
                    return;
                }
                PNGZipLoader.loadZipFromLoadedResource(response.data, callbackForFile, numberOfFilesReporter).then(resolve)
            })
        })
    }

    public static loadZipFromLoadedResource(responseData: Blob, callbackForFile: (relativePath, blob) => void, numberOfFilesReporter: (numberOfFiles) => void = noop) {
        return new Promise<void>(resolve => {
            new Response(responseData).arrayBuffer().then(r => {
                const unzipped = unzipSync(new Uint8Array(r));
                const numberOfTasks = Object.keys(unzipped).length;
                numberOfFilesReporter(numberOfTasks);
                for (const filename in unzipped) {
                    callbackForFile(filename, new Blob([unzipped[filename]]))
                }
                resolve();
            })
        });
    }
}
